import { useMissionStorage, useMissionsTranslation } from '../../../../ui/hooks';
import { handleErrorSnackbar, showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useCallback } from 'react';
import { missionWizardSteps } from '../components/missionWizardSteps';
import { useAdditionalSteps } from './useAdditionalSteps';
export const useEditMission = ({ missionId, missionData }) => {
    const { t } = useMissionsTranslation();
    const missionStorage = useMissionStorage();
    const additionalSteps = useAdditionalSteps();
    if (!missionId) {
        throw new Error('Mission id is required');
    }
    const handleSubmit = useCallback((data) => {
        return missionStorage
            .post({ action: 'partial-update', id: missionId, data: data })
            .then(() => {
            showInfoSnackbar({
                message: t('missions.updated'),
                autoHideDuration: 2000,
            });
        })
            .catch(handleErrorSnackbar);
    }, [t, missionStorage, missionId]);
    const wizardConfig = {
        steps: [...missionWizardSteps, ...(additionalSteps !== null && additionalSteps !== void 0 ? additionalSteps : [])],
        title: t('missions.editMission'),
        data: missionData,
        submitButtonLabel: t('common.saveChanges'),
        closeWizardContent: t('wizard.closeWizardContentEdit'),
        onSubmit: handleSubmit,
    };
    return {
        wizardConfig,
    };
};
